module.exports = __webpack_public_path__ + "modules/home/images/saas_4.png?8b8ef401";


//////////////////
// WEBPACK FOOTER
// ./modules/home/images/saas_4.png
// module id = 79
// module chunks = 0